import { GatewayTicketModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/tickets/models/outputs/gateway-ticket.model';
import { CreateTicketModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/support-service-lib/src/wrapper/inputs/create-ticket.model';
import { createContext, useContext } from 'react';
import { DeepPartialSkipArrayKey } from 'react-hook-form';

export const TicketContext = createContext<GatewayTicketModel | null>(null);

export const useTicketContext = (): GatewayTicketModel => {
  const context = useContext(TicketContext);

  if (!context) {
    throw new Error(
      'useTicketContext must be used within TicketContext.Provider',
    );
  }

  return context;
};

interface TicketContextProviderProps {
  data: GatewayTicketModel;
  children: React.ReactNode;
}

export const TicketContextProvider = ({
  data,
  children,
}: TicketContextProviderProps): React.JSX.Element => {
  return (
    <TicketContext.Provider value={data}>{children}</TicketContext.Provider>
  );
};

export const UpdateTicketContext = createContext<
  (DeepPartialSkipArrayKey<CreateTicketModel> & { id: string }) | null
>(null);

export const useUpdateTicketContext =
  (): DeepPartialSkipArrayKey<CreateTicketModel> & { id: string } => {
    const context = useContext(UpdateTicketContext);

    if (!context) {
      throw new Error(
        'useUpdateTicketContext must be used within UpdateTicketContext.Provider',
      );
    }

    return context;
  };

interface UpdateTicketContextProviderProps {
  data: DeepPartialSkipArrayKey<CreateTicketModel> & { id: string };
  children: React.ReactNode;
}

export const UpdateTicketContextProvider = ({
  data,
  children,
}: UpdateTicketContextProviderProps): React.JSX.Element => {
  return (
    <UpdateTicketContext.Provider value={data}>
      {children}
    </UpdateTicketContext.Provider>
  );
};
